// Сэтгэл ханамжийн асуулга — /survey/:id (мэдэгдлийн холбоос). Асуулгын картыг харуулж, бөглөх цонхыг шууд нээнэ.
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Spin } from "antd";
import { FiArrowLeft } from "react-icons/fi";
import SurveyCards from "./Cards";

export default function SurveyPage() {
  const { id } = useParams();
  const [list, setList] = useState(undefined);
  return (
    <div className="pt-3.5 md:pt-7 pb-8 max-w-[760px] mx-auto flex flex-col gap-4">
      <Link to="/" className="self-start inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:text-[#3d1b6e] min-h-[44px]">
        <FiArrowLeft size={16} /> Нүүр
      </Link>
      {list === undefined && <div className="flex justify-center py-10"><Spin /></div>}
      {list && !list.length && (
        <section className="tj-card p-6 text-center text-sm text-[#6e5e8a]">Энэ асуулга олдсонгүй эсвэл хаагдсан байна.</section>
      )}
      <SurveyCards key={id} only={id} autoOpen onLoaded={setList} />
    </div>
  );
}
